<template>
  <Widget
    class="chart-widget"
    :title="title"
    :tooltip="tooltip"
    :loading="loading"
    :action-handler="actionHandler"
    title-type="thin"
  >
    <div class="widget-body" v-if="hasData">
      <div class="chart-container">
        <DoughnutChart :dataset="dataset" />
      </div>
      <ChartLegend :dataset="dataset" />
    </div>
    <NoData v-else class="my-auto" />
  </Widget>
</template>

<script>
import Widget from "@/components/Dashboard/base/Widget";
import DoughnutChart from "@/components/Dashboard/base/DoughnutChart";
import ChartLegend from "@/components/Dashboard/base/ChartLegend";
import NoData from "@/components/ui/NoData";

export default {
  name: "DashboardValueWidget",
  components: {
    Widget,
    DoughnutChart,
    ChartLegend,
    NoData
  },
  props: {
    title: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      required: true
    },
    dataset: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    actionHandler: {
      type: Function,
      default: () => void 0
    }
  },
  computed: {
    hasData() {
      return this.dataset.some(item => !!item.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.widget-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;

  .chart-container {
    max-width: 260px;
    max-height: 260px;
    width: 100%;
    height: 100%;
    margin-top: $spacing * 4;
    margin-bottom: $spacing * 4;
  }
}
</style>

<style lang="scss">
.chart-widget .v-card__text {
  justify-content: flex-start !important;
}
</style>
